import * as React from 'react';
import { percent } from '@tencent/gems-shared';
import { HotAreaActionHandler } from './handlers/actionHandler';
export function HotAreas(_a) {
    var instance = _a.instance, global = _a.global, meta = _a.meta;
    var hotAreas = instance.data.hotAreas;
    if (!hotAreas || !hotAreas.length) {
        return null;
    }
    return hotAreas.map(function (hotArea, index) {
        var size = hotArea.size, position = hotArea.position;
        return (React.createElement(HotAreaActionHandler, { key: index, instance: instance, hotArea: hotArea, meta: meta, global: global, style: {
                width: percent(size.width),
                height: percent(size.height),
                left: percent(position.x),
                top: percent(position.y),
                cursor: 'pointer',
                position: 'absolute',
                zIndex: 20,
            } }));
    });
}
//# sourceMappingURL=HotAreas.js.map